import React from 'react';
import {
  Box,
  Container,
  Row,
  Column,
  FooterLink,
  FooterLinkDarkTheme,
  Heading,
  Tagline,
  MetaNote,
  Brand,
  BrandMark,
  LegalRow,
} from './FooterStyles';
import { useTheme } from '../../context/ThemeContext';

const Footer = () => {
  const { darkTheme } = useTheme();
  const Link = darkTheme ? FooterLinkDarkTheme : FooterLink;

  return (
    <Box className={darkTheme ? 'dark-theme blackBg' : ''}>
      <Container>
        <Brand>
          <BrandMark>JG Presence Engine</BrandMark>
          <Tagline>Drop-In Presence That Feels Alive</Tagline>
        </Brand>

        <Row>
          <Column>
            <Heading>Presence</Heading>
            <Link
              href="https://presence-sdk-landing.joegalaxy.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              Presence Engine Landing
            </Link>
            <Link
              href="https://www.joegalaxy.net/presence-demo"
              target="_blank"
              rel="noopener noreferrer"
            >
              Live Presence Demo
            </Link>
          <Link
            href="https://presence-sdk-demo.joegalaxy.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            SDK Demo
          </Link>
          <Link href="/docs">Docs</Link>
          <MetaNote>Powered by JG Presence Engine (live)</MetaNote>
        </Column>

          <Column>
            <Heading>Support & Legal</Heading>
            <Link
              href="mailto://support@joegalaxy.net?subject=Login Page Support Request"
              title="Joe Galaxy Login Page Support"
            >
              Support
            </Link>
            <Link
              href="https://www.termsfeed.com/live/3d1dff9b-43cf-411f-8bd0-d96a8df1d4d1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Privacy
            </Link>
          </Column>
        </Row>

        <LegalRow>
          <MetaNote>© {new Date().getFullYear()} JOEGALAXY.NET</MetaNote>
        </LegalRow>
      </Container>
    </Box>
  );
};
export default Footer;
